import { jiraBrowseUrl } from '../../global_constants';
import { Component, OnInit } from '@angular/core';
import { SupportService } from 'src/app/rest_services/msHelpServices/support.service';
import { UserService } from 'src/app/rest_services/user.service';

@Component({
  selector: 'app-support-ticket',
  templateUrl: './support-ticket.component.html',
  styleUrls: ['./support-ticket.component.css']
})
export class SupportTicketComponent implements OnInit {
  jiraBrowseUrl = jiraBrowseUrl;

  
  ticketsLoading: boolean = true;
  
  alltickets :any[] = [];

  
  constructor(
    private userService : UserService,
    private supportService : SupportService
  ) { }

  ngOnInit(): void {
    this.loadTickets();
  }

  loadTickets() {
    this.ticketsLoading = true;
    this.supportService.getRequestList();
    this.supportService.requestListSubject.subscribe(
      (response: any) => {
        this.ticketsLoading = false;
        if (response.status === '200') {
          this.alltickets = response.data;     
          this.fetchCreator();
          this.initializeDatDatble();
        } else {
          this.initializeDatDatble();
          console.error('Failed to load tickets');
        }
      },
      (error: any) => {
        console.error('There was an error!', error);
        this.ticketsLoading = false;
      }
    );
  }

  initializeDatDatble(){
    setTimeout(() => {
      (<any>$("#alter_pagination")).DataTable( {
        "destroy":true,
        "pagingType": "full_numbers",
        "scrollX": '400px',
        "scrollCollapse": true,
        aaSorting: false, // Order by the third column (Date de création) in descending order
        "iDisplayLength": 25,
        // columnDefs: [ { type: 'string', 'targets': [0], "orderable": true } ],
        "language": {
          "sProcessing": "Traitement en cours ...",
          "sLengthMenu": "Afficher _MENU_ lignes",
          "sZeroRecords": "Aucun résultat trouvé",
          "sEmptyTable": "Aucune donnée disponible",
          "sInfo": "",
          "sInfoEmpty": "",
          searchPlaceholder: "Saisir un mot clé",
          "sInfoFiltered": "",
          "sInfoPostFix": "",
          "sSearch": "Rechercher:",
          "sUrl": "",
          "sInfoThousands": ",",
          "sLoadingRecords": "Chargement...",
          "oPaginate": {
            "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
          },
          "oAria": {
            "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
          }
        },
        drawCallback: function () {
          (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                type: 'line',
                width: '60',
                height: '20',
                lineColor: '#1a73e9',
                fillColor: '#c2d5ff',
                spotColor: 'transparent',
                minSpotColor: 'transparent',
                maxSpotColor: 'transparent',
                highlightSpotColor: 'transparent',
                highlightLineColor: 'transparent',
            });
        }
      });
    }, 1000);
  }
  fetchCreator() {
    this.alltickets.forEach((ticket: any) => {
      const userId = ticket.createdBy; // Assuming userId is the user UUID
      this.userService.getUserFilteredData(userId, ['fullName','company']).subscribe(
        (userData: any) => {
          if (userData) {
            console.log(userData);
            
            ticket.creator = userData.connected_user.user_fullname;
            ticket.organisation = userData.connected_user.company_name;
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);
          // Handle error if needed
        }
      );
    });
  }


}
